import { FC } from 'react'
import { MarketingPageRoutes } from '@dtx-company/true-common/src/constants/routes'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { containerStyles } from '@app/common/src/components/PlanPurchaseExperience/components/PlanPurchaseExperience.styles'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import styled from '@emotion/styled'
import theme from '../../../theme'

export interface SubHeadingLinkProps {
  selectedPlan: Plan | undefined
}

export const SubHeadingLink: FC<SubHeadingLinkProps> = props => {
  return (
    <_LinkText>
      <a
        onClick={() => {
          fireAnalyticsEvent('Revenue_Upgrade_Clicked_LearnMoreLink')
        }}
        target="_blank"
        rel="noreferrer"
        href={
          props.selectedPlan?.type == PlanType.PRO_PLUS_ORG
            ? MarketingPageRoutes.PRO_PLUS
            : MarketingPageRoutes.PRO
        }
      >
        {'Learn more about this plan ->'}
      </a>
    </_LinkText>
  )
}

const _LinkText = styled(Text)`
  && {
    ${containerStyles};
    color: ${theme.colors.primary.flowBlue};
    margin-top: 8px;
  }
`
